import React, { Fragment, useState, useCallback } from 'react';
import { Button, CssBaseline, TextField, Link, Grid, Typography } from '@material-ui/core'
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useCookies } from "react-cookie";
import { useHistory } from "react-router-dom";
import { useLongPress } from 'use-long-press';
import ToastStr from '../request/toastStr';

import axios from 'axios'

import { COLORS } from './Theme'
import { SIcon } from './Icon';

import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../request/values';
import { useSnackbar } from 'notistack';

const SERVER = basic.server;

const useStyles = makeStyles((theme : any) => ({

  background: {
    position: 'absolute',
    top: 0,
    width: '100vw',
    height: '170vh',
    background: `url("/images/background.png")`,
  },
  container: {
    padding: 0,
    height: '100vh',
    paddingTop: '15vh',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    width: '30vw',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '30vw', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  emailCheck: {
    height: '50px',
    width: '30vw',
    margin: theme.spacing(3, 0, 2),
    borderRadius: '15px',
    boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
    border: 'solid 0.5px #cfd4d9',
    backgroundColor: `${COLORS.WATER_BLUE}`,
    "&:hover": {
      backgroundColor:`${COLORS.WATER_BLUE}`,
    }
  },
  signin: {
    height: '50px',
    width: '30vw',
    margin: theme.spacing(3, 0, 2),
    borderRadius: '15px',
    boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
    border: 'solid 0.5px #cfd4d9',
    backgroundColor: `${COLORS.WATER_BLUE}`,
    marginTop: '1vh',
    "&:hover": {
      backgroundColor:`${COLORS.WATER_BLUE}`,
    }
  },
  submitButton: {
    "& :hover": {
      backgroundColor:`${COLORS.WATER_BLUE}`,
    }
  },
  logoSection: {
    // position: 'absolute',
    // bottom: '5vh',
    // width: '100vw',
    // textAlign: 'center'
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
    alignItems: 'flex-end',
    marginTop: '20vh',
    marginBottom: '10vh',
  },
  logobutton: {
    border: 'none',
    backgroundColor: 'transparent',
  },
  buttonFont: {
    color: `${COLORS.WHITE}`,
    fontSize: '2vw'
  },
  border: {
    borderWidth: 5,
    borderStyle: 'solid',
    borderColor: `#000000`,
    background: `${COLORS.WHITE}`,
    padding: '1vw',
    marginTop: '1vh'
  }
}));


const AdminSignin: React.FC<any> = props => {
  const classes = useStyles();

  const [email, setEmail] = useState<any | null>();
  const [password, setPassword] = useState<any | null>();
  const [passwordCheck, setPasswordCheck] = useState<any | null>();
  const [name, setName] = useState<any | null>();
  const [phone, setPhone] = useState<any | null>();
  const [company, setCompany] = useState<any | null>();
  const history = useHistory();
  const [auth, setAuth] = useState<boolean>(false);
  const [cookies, setCookie, removeCookie] = useCookies();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { admin, setAdmin, token } = props;


  const buttonText = ["이메일 중복 확인하기", "확인 완료"]


  const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;

    if (id == 'email') setEmail(value);
    else if (id == 'password') setPassword(value);
    else if (id == 'passwordCheck') setPasswordCheck(value);
    else if (id == 'name') setName(value);
    else if (id == 'phone') setPhone(value);
    else if (id == 'company') setCompany(value);
    
  }


  const emailCheck = () => {
    let url = new URL(SERVER + v_admin.admin + v_admin.auth_app_info);
    let params = { 'email': email ? email.toString().trim() : '', 'action': 'join' }
    url.search = new URLSearchParams(params).toString();

    axios({
        method: 'GET',
        withCredentials: true,
        url: url.toString(),
    }).then((res) => {
        return res.data
    }).then((data: any) => {
        console.log(data);
        if (data.code == Values.SUCCESS_CODE) {
            enqueueSnackbar(ToastStr.EMAIL_DUPLICATION, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
        } else if (data.code == Values.FAIL_CODE) {
            // this is success == dont exist same id
            enqueueSnackbar(ToastStr.EMAIL_AUTH_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME * 2 })
            setAuth((prevState) => true);
        }
    })
  }

  const handleButton = (e: any) => {
    // e.preventDefault();
    
    if (auth) {
      enqueueSnackbar(ToastStr.EMAIL_AUTH_SUCCESS_STR, { variant: "success", autoHideDuration: SNACKBAR_TIME })
    } else {
        // setAnimation(true);
        if (email.length  == 0) {
            enqueueSnackbar(ToastStr.EMAIL_ADDR_CHECK_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
        } else if(email.length > 32) {
            enqueueSnackbar(ToastStr.EMAIL_ADDR_CHECK_LEN, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
        } else {
            emailCheck();
        }
    }
    
}

  const submitSignin = (event: any) => {
    if(password != passwordCheck) {
      enqueueSnackbar(ToastStr.PWD_CHECK_FALSE_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
    }
    else if (company == "") {
      enqueueSnackbar(ToastStr.COMPANY_NAME_CHECK_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
    }
    else {
      axios({
        method: "POST",
        data: {
            name: name,
            phone: phone,
            email: email,
            pwd: password,
            companyName: company,
        },
        withCredentials: true,
        url: SERVER + v_admin.admin + v_admin.join,
    })
        .then((res) => {
            return res.data
        }).then((data: any) => {
            console.log(data)
            if (data.code == Values.SUCCESS_CODE) {
                history.push({
                    pathname: '/admin',
                });
            } else {
                if (data.code == Values.FAIL_CODE) {
                    enqueueSnackbar(ToastStr.JOIN_FAIL_STR, { variant: "warning", autoHideDuration: SNACKBAR_TIME })
                } else {
                    enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: "error", autoHideDuration: SNACKBAR_TIME })
                }
            }
        })
    }
  }

  return (
    <div className={classes.background}>
      <Container component="main" className={classes.container}>
        <CssBaseline />
        <div className={classes.paper}>
          <div className={classes.title}>
            <Typography variant="h2" style={{ color: `${COLORS.WATER_BLUE}`, textAlign: 'center', fontWeight: 'bold'}}>
              플레이스타트업
            </Typography>
            <Typography variant="h2" style={{ color: `${COLORS.WATER_BLUE}`, textAlign: 'center', fontWeight: 'bold'}}>
              운영자 회원가입
            </Typography>
          </div>
        <div className={classes.border}>
            <Typography style={{ color: `${COLORS.BLACK}`, textAlign: 'left', fontWeight: 'bold', fontSize: '1.5vw'}}>
                이메일
            </Typography>
            <div className={classes.form}>
                <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                id="email"
                label="이메일을 입력해주세요"
                name="email"
                autoComplete="email"
                autoFocus
                value={email}
                onChange={valueChangeHandler}
                style={{ color: `${COLORS.charcoal_grey}`, marginTop: 0 }}
                />
                <Button
                // type="submit"
                fullWidth
                variant="contained"
                className={classes.emailCheck}
                onClick={(e) => handleButton(e)}
                >
                <Typography className={classes.buttonFont}>
                  {auth ? buttonText[1] : buttonText[0]}
                </Typography>
                </Button>
                <Typography style={{ color: `${COLORS.BLACK}`, textAlign: 'left', fontWeight: 'bold', fontSize: '1.5vw'}}>
                    비밀번호
                </Typography>
                <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="password"
                label="비밀번호 입력"
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={valueChangeHandler}
                style={{ color: `${COLORS.charcoal_grey}` }}
                />
                <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="passwordCheck"
                label="비밀번호 확인"
                type="password"
                id="passwordCheck"
                autoComplete="current-password"
                value={passwordCheck}
                onChange={valueChangeHandler}
                style={{ color: `${COLORS.charcoal_grey}` }}
                />
                <Typography style={{ color: `${COLORS.BLACK}`, textAlign: 'left', fontWeight: 'bold', fontSize: '1.5vw'}}>
                    이름
                </Typography>
                <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="name"
                label="이름 입력"
                type="name"
                id="name"
                autoComplete="current-name"
                value={name}
                onChange={valueChangeHandler}
                style={{ color: `${COLORS.charcoal_grey}` }}
                />
                <Typography style={{ color: `${COLORS.BLACK}`, textAlign: 'left', fontWeight: 'bold', fontSize: '1.5vw'}}>
                    전화번호
                </Typography>
                <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="phone"
                label="전화번호 입력"
                type="phone"
                id="phone"
                autoComplete="current-phone"
                value={phone}
                onChange={valueChangeHandler}
                style={{ color: `${COLORS.charcoal_grey}` }}
                />
                <Typography style={{ color: `${COLORS.BLACK}`, textAlign: 'left', fontWeight: 'bold', fontSize: '1.5vw'}}>
                    기업명
                </Typography>
                <TextField
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="company"
                label="기업명 입력"
                type="company"
                id="company"
                autoComplete="current-company"
                value={company}
                onChange={valueChangeHandler}
                style={{ color: `${COLORS.charcoal_grey}` }}
                />

                <Button
                // type="submit"
                fullWidth
                variant="contained"
                className={classes.signin}
                onClick={(e) => submitSignin(e)}
                >
                <Typography className={classes.buttonFont}>
                    회원가입하기
                </Typography>
                </Button>
            </div>
        </div>
          <div className={classes.logoSection}>
                <SIcon type="P" />
          </div>
        </div>
      </Container>
    </div>

  );
}

export default AdminSignin;
